import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsCheckboxModule,
    CmpsIconModule,
    CmpsIconRegistry,
} from '@cmps/ng-uikit';
import { mdiCalendar, mdiChevronDown, mdiClose } from '@mdi/js';

import { CmpsPopulationCompareComponent } from './population-compare.component';
import { FilterPipe } from './population-compare.filter';

@NgModule({
    declarations: [CmpsPopulationCompareComponent, FilterPipe],
    imports: [
        CmpsIconModule,
        CmpsButtonModule,
        CmpsCheckboxModule,
        CommonModule,
        FormsModule,
    ],
    exports: [CmpsPopulationCompareComponent],
})
export class CmpsPopulationCompareModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['close', mdiClose],
            ['calendar', mdiCalendar],
            ['chevron-down', mdiChevronDown],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
